import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost } from "../../Services/ApiService";

export const getWishlistAPI = (params, callBack) => {
  return async () => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await apiGet(`${ApiConstants.wishlistUrl}?${query}`);
      callBack && callBack(response, response?.data);
    } catch (error) {
      console.log("get wishlist api err:", error);
      throw error;
    }
  };
};

export const addWishlistAPI = (data, callBack) => {
  return async () => {
    try {
      const response = await apiPost(`${ApiConstants.wishlistUrl}`, data);

      callBack && callBack(response, response);
    } catch (error) {
      console.log("add wishlist api err:", error);
      throw error;
    }
  };
};

// export const removeWishlistAPI = (data, callBack) => {
//   return async () => {
//     try {
//       const response = await apiDelete(
//         `${ApiConstants.wishlistUrl}?wishlist_id=${data}`,
//         data
//       );
//       callBack && callBack(response?.data, response?.data);
//     } catch (error) {
//       console.log("remove wishlist api err:", error);
//       throw error;
//     }
//   };
// };

// export const removeWishlistAPI = (wishlistId, callBack) => {
//   return async () => {
//     try {
//       const response = await apiDelete(
//         `${ApiConstants.wishlistUrl}?wishlist_id=${wishlistId}`
//       );
//       console.log("Wishlist remove response:", response);
//       callBack && callBack(response?.data, response?.data);
//     } catch (error) {
//       console.log("remove wishlist api error:", error);
//       throw error;
//     }
//   };
// };

export const removeWishlistAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(`${ApiConstants.wishlistUrl}`, data).then(
        (response) => {
          console.log("remove wishlist response:", response);
          callBack && callBack(response?.data, response?.data);
        }
      );
    } catch (error) {
      console.log("remove wishlist api error:", error);
      throw error;
    }
  };
};
